module.exports = __webpack_public_path__ + "img/8th hakurei shrine fall reitaisai.a1b36659.png";